<template>
  <div class="sticky compatible-sticky" id="bottom-bar">
    <bottom-bar-button v-if="playShow&&!isDiscontinued" @click.native="toPlay" :type="styleType.left">
      <img v-if="play.icon" :src="play.icon" alt="" class="icon">
      <div class="text" v-html="play.text"></div>
    </bottom-bar-button>
    <bottom-bar-button v-if="shareShow&&!isDiscontinued" @click.native="toShare" :type="styleType.left">
      <img v-if="share.icon" :src="share.icon" alt="" class="icon">
      <div class="text" v-html="share.text"></div>
    </bottom-bar-button>
    <bottom-bar-button v-if="buyShow&&!isDiscontinued" @click.native="toBuy" :type="styleType.right">
      <img v-if="buy.icon" :src="buy.icon" alt="" class="icon">
      <div class="text" v-html="buy.text"></div>
    </bottom-bar-button>
    <bottom-bar-button v-if="isDiscontinued" @click.native="showTips" :type="styleType.right">
      <div class="text">暂停销售</div>
    </bottom-bar-button>
    <div class="compatible"></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import BottomBarButton from './bottomBarButton';
import { resourceType, albumGoodsType } from '@/utils/const';
export default {
  components: { BottomBarButton },
  props: {
    play: {
      type: Object,
      default: () => {},
    },
    share: {
      type: Object,
      default: () => {},
    },
    buy: {
      type: Object,
      default: () => {},
    },
    isDiscontinued: {
      type: Boolean,
      default: false,
    },
    styleType: {
      type: Object,
      default: () => ({ left: 'primary', right: 'normalBuy' }),
    },
  },
  methods: {
    toPlay() {
      this.$emit('bottomBarHandler', 'toPlay');
    },
    toShare() {
      this.$emit('bottomBarHandler', 'toShare');
    },
    toBuy() {
      this.$emit('bottomBarHandler', 'toBuy');
    },
    showTips() {
      this.$store.commit('setToastShow', {
        show: true,
        content: {
          txt: '因版权相关因素，该专辑暂停销售',
          type: 'txt',
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      isPlusMember: 'auth/isPlusMember',
      userInfo: 'auth/userInfo',
    }),
    playShow() {
      return !isEmpty(this.play);
    },
    shareShow() {
      return !isEmpty(this.share);
    },
    buyShow() {
      return !isEmpty(this.buy);
    },
  },
};
</script>
<style scoped>
.sticky {
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
  align-items: center;
  z-index: 3
}
.sticky > a {
  display: block;
  flex: 1;
  text-align: center;
  font-size: 16px;
  line-height: 52px;
}
.text {
  display: inline-block;
  font-size: 16px;
}
.sticky >>> .buy span {
  font-size: 12px;
}

.sticky >>> .normal span {
  font-size: 12px;
}
.sticky .icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
}
.normalBuy.vip-bg {
  background: #ff6886;
}
.primary.vip-bg {
  background: rgba(116, 179, 250, 1);
  color: #fff;
  border-radius: 16px 16px 0px 0px;
}
.vip-icon {
  width: 17px;
  height: 18px;
  margin-right: 6px;
  vertical-align: middle;
}
</style>



